import { PortalViewId } from './portalViewIds';
import type { ViewConfiguration } from './types';

export const staffMemberViewConfiguration: ViewConfiguration = {
  viewIds: [
    PortalViewId.Home,
    PortalViewId.PropertiesList,
    PortalViewId.PropertiesDetails,
    PortalViewId.PropertiesSettings,
    PortalViewId.PropertiesOpeningHours,
    PortalViewId.PropertiesSalesChannels,
  ],
};
